import * as Yup from 'yup'

export const schema = Yup.object({
  currentPassword: Yup.string().required('Campo obrigatório.'),
  password: Yup.string().required('Campo obrigatório.'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), undefined], 'Senhas não são iguais')
    .required('Campo obrigatório.'),
})
